define('maps/layers/tracklabelslayer',["require", "exports", "../../baseline/colors", "../icons"], function (require, exports, colors, icons_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.TrackLabelsLayer = void 0;
    var TrackLabelsLayer = /** @class */ (function () {
        function TrackLabelsLayer(track) {
            this.track = track;
        }
        TrackLabelsLayer.prototype.onAddGoogle = function (googleMap) {
            this.googleMap = googleMap;
        };
        // Called when track data has changed
        TrackLabelsLayer.prototype.update = function () {
            if (!this.googleMap)
                return;
            // Remove previous layers
            if (this.exit)
                this.exit.setMap(null);
            if (this.deploy)
                this.deploy.setMap(null);
            if (this.land)
                this.land.setMap(null);
            // Add markers
            if (this.track.stats.exit) {
                this.exit = makersMark(colors.exitColor, this.track.stats.exit, "Exit", this.googleMap);
            }
            if (this.track.stats.deploy) {
                this.deploy = makersMark(colors.deployColor, this.track.stats.deploy, "Deploy", this.googleMap);
            }
            if (this.track.stats.land) {
                this.land = makersMark(colors.landColor, this.track.stats.land, "Land", this.googleMap);
            }
        };
        TrackLabelsLayer.prototype.onRemove = function () {
            this.googleMap = undefined;
        };
        return TrackLabelsLayer;
    }());
    exports.TrackLabelsLayer = TrackLabelsLayer;
    /**
     * Make a new marker
     */
    function makersMark(color, position, title, map) {
        return new google.maps.Marker({
            icon: (0, icons_1.pin)(color),
            map: map,
            position: position,
            title: title
        });
    }
});
//# sourceMappingURL=/assets/javascripts/maps/layers/tracklabelslayer.js.map;
